/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("digiexam").
controller("CreateExamController", function CreateExamController(
	$document,
	$filter,
	$interval,
	$location,
	$rootScope,
	$route,
	$routeParams,
	$scope,
	$timeout,

	DX_EXAMS_STEPS,
	DX_QUESTION_TYPE,
	DX_SPELLCHECKSETTING,
	DX_TEXT_TO_SPEECH_SETTING,
	DX_IMMERSIVE_READER_SETTING,
	DX_USB_AUDIO_SETTING,
	DX_EXAM_PARTS,
	DX_PRINT_SETTINGS,
	DX_PAGE_BREAK,
	dxEvent,
	dxExamsNavigator,
	DX_QUESTION_GRADING_TYPE,
	DX_URLS,
	dxScrollIntoView,
	dxSession,
	dxSorting,
	Exam,
	ExamDraftRepository,
	ExamRepository,
	NodeRepository,
	DX_REMOTE_PROCTOR_SETTING,

	DX_CAP_SETTINGS,
	DX_GRADING_TYPES,
	DX_RESOURCE_TYPE,
	dxDialog,
	dxLocalize,
	dxApi,
	dxBitFlagsHelper,
	dxAngularConstantHelper
) {
	"use strict";

	$scope.reqs = {
		exam: false,
	};

	var lastRoute = $route.current;
	var preventReload = false;
	var DX_EVENT_NAME = dxAngularConstantHelper.DX_EVENT_NAME;
	var isWordgapIdDuplicated = false;
	var WORDGAP_ID_ATTRIBUTE = "dx-wg-id";
	var BASE_UUID = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";

	$scope.DX_GRADING_TYPES = DX_GRADING_TYPES;
	$scope.DX_QUESTION_GRADING_TYPE = DX_QUESTION_GRADING_TYPE;
	$scope.DX_QUESTION_TYPE = DX_QUESTION_TYPE;
	$scope.DX_RESOURCE_TYPE = DX_RESOURCE_TYPE;
	$scope.DX_SPELLCHECKSETTING = DX_SPELLCHECKSETTING;
	$scope.DX_TEXT_TO_SPEECH_SETTING = DX_TEXT_TO_SPEECH_SETTING;
	$scope.DX_USB_AUDIO_SETTING = DX_USB_AUDIO_SETTING;
	$scope.DX_IMMERSIVE_READER_SETTING = DX_IMMERSIVE_READER_SETTING;

	$scope.remoteProctoringHelpUrl = dxLocalize.getLanguage() === "sv" ?
		"https://support.digiexam.se/hc/sv/articles/360013609919" :
		"https://support.digiexam.se/hc/en-us/articles/360013609919";

	$scope.lockedQuestionSequenceHelpUrl = dxLocalize.getLanguage() === "sv" ?
		"https://support.digiexam.se/hc/sv/articles/360022944874" :
		"https://support.digiexam.se/hc/en-us/articles/360022944874";

	$scope.immersiveReaderHelpUrl = dxLocalize.getLanguage() === "sv" ?
		"https://support.digiexam.se/hc/sv/articles/360008144040" :
		"https://support.digiexam.se/hc/en-us/articles/360008144040";

	$scope.anonymousExamHelpUrl = dxLocalize.getLanguage() === "sv" ?
		"https://digiexam.zendesk.com/hc/sv/articles/203141022-Anonyma-prov-tentor" :
		"https://digiexam.zendesk.com/hc/en-us/articles/203141022-How-anonymous-exams-work";

	$scope.externalCopyPasteUrl = dxLocalize.getLanguage() === "sv" ?
		"https://support.digiexam.se/hc/sv/articles/6533413635228" :
		"https://support.digiexam.se/hc/en-us/articles/6533413635228-The-student-text-editor-in-the-Digiexam-application";

	$scope.editorFocus = {};

	$scope.$on("$locationChangeSuccess", function success() {
		if (preventReload) {
			$route.current = lastRoute;
			preventReload = false;
		}
	});

	$scope.questionTypes = [
		{displayName: dxLocalize.get("TextQuestion"), type: 0},
		{displayName: dxLocalize.get("SingleChoiceQuestion"), type: 1},
		{displayName: dxLocalize.get("MultiChoiceQuestion"), type: 2},
		{displayName: dxLocalize.get("WordGapQuestion"), type: 3},
	];

	$scope.assessmentTypes = [
		{displayName: dxLocalize.get("ScoreBasedGrading"), value: DX_GRADING_TYPES.SCORE},
		{displayName: dxLocalize.get("RubricBasedAssessment"), value: DX_GRADING_TYPES.FORMATIVE},
	];

	$scope.openBookSettings = [
		{displayName: dxLocalize.get("On"), value: false},
		{displayName: dxLocalize.get("Off"), value: true},
	];

	$scope.allowExternalPasteSettings = [
		{displayName: dxLocalize.get("On"), value: true},
		{displayName: dxLocalize.get("Off"), value: false},
	];

	$scope.remoteProctoringEnabledSettings = [
		{displayName: dxLocalize.get("On"), value: true},
		{displayName: dxLocalize.get("Off"), value: false},
	];

	$scope.spellcheckSettings = [
		{displayName: dxLocalize.get("Spellcheck.Setting.0"), value: 0},
		{displayName: dxLocalize.get("Spellcheck.Setting.1"), value: 1},
		{displayName: dxLocalize.get("Spellcheck.Setting.2"), value: 2},
	];

	$scope.textToSpeechSettings = [
		{displayName: dxLocalize.get("TextToSpeech.Setting.0"), value: 0},
		{displayName: dxLocalize.get("TextToSpeech.Setting.1"), value: 1},
		{displayName: dxLocalize.get("TextToSpeech.Setting.2"), value: 2},
	];

	$scope.usbAudioSettings = [
		{displayName: dxLocalize.get("UsbAudio.Setting.0"), value: 0},
		{displayName: dxLocalize.get("UsbAudio.Setting.1"), value: 1},
		{displayName: dxLocalize.get("UsbAudio.Setting.2"), value: 2},
	];

	$scope.immersiveReaderSettings = [
		{displayName: dxLocalize.get("ImmersiveReader.Setting.0"), value: 0},
		{displayName: dxLocalize.get("ImmersiveReader.Setting.1"), value: 1},
		{displayName: dxLocalize.get("ImmersiveReader.Setting.2"), value: 2},
	];

	$scope.capSettings = [
		{displayName: dxLocalize.get("NoLimit"), value: DX_CAP_SETTINGS.NONE},
		{displayName: dxLocalize.get("SoftLimit"), value: DX_CAP_SETTINGS.SOFT},
		{displayName: dxLocalize.get("HardLimit"), value: DX_CAP_SETTINGS.HARD},
	];

	$scope.onOffSettings = [
		{displayName: dxLocalize.get("On"), value: true},
		{displayName: dxLocalize.get("Off"), value: false},
	];

	$scope.questionType = $scope.questionTypes[0];
	$scope.exam = new Exam();
	$scope.exam.userId = dxSession.getUser().id;
	$scope.dxSession = dxSession;
	$scope.showLibrary = true;
	$scope.isSaving = false;
	$scope.isExamValid = false;
	$scope.saveMessage = "";
	$scope.examWatcher = null;
	$scope.hasSavedManually = false;
	$scope.showMediaWarning = false;
	$scope.showHelp = false;
	$scope.featureRemoteProctoringEnabled = false;
	$scope.activeSettingsTab = "general";
	$scope.externalTools = [];
	var isExternalToolsLoaded = false;
	var isExamLoaded = false;
	$scope.canCheckForDeletedExternalTools = false;

	$scope.errors = [];


	// Load exam.
	var examId = 0;
	if ($routeParams.id) {
		examId = parseInt($routeParams.id, 10);
	}

	$scope.examPrintUrl = "";
	if (examId) {
		setExamPrintUrl(examId);
	}

	function setExamPrintUrl(printedExamId) {
		$scope.examPrintUrl = DX_URLS.get("examPrint", {
			id: printedExamId,
			examParts: DX_EXAM_PARTS.EXAM_PRINT_PARTS,
			printSettings: DX_PRINT_SETTINGS.DEFAULT,
			pageBreakBefore: DX_PAGE_BREAK.NO_PAGE_BREAK,
		});
	}

	NodeRepository.load(dxSession.getRole().organizationId).then(function onNodeLoadSuccess(node) {
		$scope.featureRemoteProctoringEnabled = dxBitFlagsHelper.isBitIncluded(node.remoteProctoringSetting, DX_REMOTE_PROCTOR_SETTING.ProctoringEnabled);
	});

	function showLoadDraftDialog() {
		dxDialog.confirm({
			title: dxLocalize.get("LoadDraft"),
			body: draftDialogBodyText(),
			acceptText: dxLocalize.get("LoadDraft"),
			acceptCallback: $scope.useDraft,
			rejectText: dxLocalize.get("NoDiscardDraft"),
			rejectCallback: $scope.discardDraft,
		});
	}

	$scope.onExamChange = function onExamChange(newValue, oldValue) {
		if (angular.equals(newValue, oldValue)) {
			return;
		}

		if (!$scope.isSaving) {
			$scope.exam.setDirty(true);
		}

		$scope.hasSavedManually = false;

		$scope.exam.parseExam();

		// Use $timeout to defer the action until after angular has done it's rendering
		// and assigned $$hashKey property.
		$timeout(function timeout() {
			validateExam();
		});
	};

	$scope.startExamWatch = function startExamWatch() {
		if (!$scope.examWatcher) {
			// Needed for saved exams with loaded draft, since the exam watch won't trigger
			// until a change is made.
			$timeout(function timeout() {
				validateExam();
			});

			$scope.examWatcher = $scope.$watch("exam", $scope.onExamChange, true);
			isExamLoaded = true;
			$scope.canCheckForDeletedExternalTools = isExamLoaded && isExternalToolsLoaded;
		}
	};

	$scope.stopExamWatch = function stopExamWatch() {
		if ($scope.examWatcher) {
			$scope.examWatcher();
			$scope.examWatcher = null;
		}
	};

	$scope.loadDraft = function loadDraft() {
		// Load draft.
		ExamDraftRepository.load(examId).then(function setDraft(draftRepo) {
			if (draftRepo === null) {
				$scope.reqs.exam = true;
				deferStartExamWatcher();
			} else {
				$scope.draft = draftRepo.examDraft;
				$scope.draftLastModified = draftRepo.lastModified;
				showLoadDraftDialog();
			}
		});
	};

	function deferStartExamWatcher() {
		// When exams are saved in the backend the HTML is unescaped e.g. '&aring' turns into 'å'.
		// Then, when Froala loads the data back into the editor it escapes the HTML, i.e. 'å' turns back into '&aring'.
		// This causes a draft save to be triggered when loading an exam since the content has "changed".
		// Defer starting the exam watcher until the next digest cycle so that Froala has time to transform the HTML.
		// This avoids the unnecessary draft save call when loading an exam.
		// 2021-01-11: Have not tested if this is still needed since editor converting to new Froala / Angular
		$timeout(function timeout() {
			$scope.startExamWatch();
		});
	}

	function validateExam() {
		$scope.errors = [];
		$scope.errorMessage = "";

		$scope.errors = $scope.errors.concat($scope.exam.getErrorList());

		validateExternalToolSettings();

		$scope.isExamValid = $scope.errors.length === 0;
		return $scope.isExamValid;
	}

	function validateExternalToolSettings() {
		$scope.exam.externalToolSettings.forEach(function forEachFn(settings) {
			var externalTool = $scope.externalTools.find(function findFn(tool) {
				return tool.id === settings.externalToolId;
			});

			if (externalTool && settings.isLandingPageMissing(externalTool)) {
				$scope.errors.push({id: "tool_landingPageUrl", msg: dxLocalize.get("ExternalToolSettings.EnterLandingPageError", externalTool.title)});
			}
		});
	}

	if (examId) {
		ExamRepository.load(examId).then(function load(exam) {
			// Copy the exam object here, since editing the library exam directly might fool the teacher that the edits are auto saved.
			$scope.exam = angular.copy(exam);

			if ($scope.exam.userId === dxSession.getUser().id) {
				$scope.loadDraft();
			} else {
				$scope.reqs.exam = true;
			}

			$scope.isExamValid = true;
			$scope.hasSavedManually = true;
			$scope.randomizeDuplicatedWordgapIds();
		});
	} else {
		$scope.startExamWatch();
		$scope.loadDraft();
	}

	dxEvent.create(DX_EVENT_NAME.PageviewCreateExam);

	// DRAFT DIALOGS - Could probably be handled better..
	$scope.useDraft = function useDraft() {
		$scope.reqs.exam = true;
		$scope.exam = $scope.draft;
		dxDialog.closeMostRecent();
		$scope.startExamWatch();
	};

	$scope.discardDraft = function discardDraft() {
		function confirmDiscardDraft() {
			ExamDraftRepository.save(examId, "").then(function save() {
				$scope.reqs.exam = true;
				$scope.hasSavedManually = true;
				dxDialog.closeMostRecent();
				deferStartExamWatcher();
			});
		}

		dxDialog.confirm({
			title: dxLocalize.get("AreYouReallySure"),
			body: dxLocalize.get("Action.CannotBeUndone"),
			acceptText: dxLocalize.get("Confirm"),
			acceptCallback: confirmDiscardDraft,
			rejectText: dxLocalize.get("Cancel"),
			rejectCallback: showLoadDraftDialog,
			escapeToClose: false,
		});
	};

	$scope.randomizeDuplicatedWordgapIds = function randomizeDuplicatedWordgapIds() {
		var questions = $scope.exam.questions.map(function getBodyHTML(question) {
			return createElementFromHTML(question.bodyHTML);
		});

		var wordgaps = questions.reduce(function getWordgap(acc, curr) {
			var currentWordgaps = Array.from(curr.querySelectorAll("span")).filter(function getSpans(span) {
				return span.getAttribute(WORDGAP_ID_ATTRIBUTE);
			});
			return acc.concat(currentWordgaps);
		}, []);

		var wordgapIds = wordgaps.map(function getIds(wordgap) {
			return wordgap.getAttribute(WORDGAP_ID_ATTRIBUTE);
		});

		for (var i = 0; i < wordgapIds.length; i++) {
			if (wordgapIds.indexOf(wordgapIds[i]) !== i) {
				isWordgapIdDuplicated = true;
				wordgaps[i].setAttribute(WORDGAP_ID_ATTRIBUTE, generateUUID());
			}
		}

		if (isWordgapIdDuplicated) {
			for (var j = 0; j < questions.length; j++) {
				$scope.exam.questions[j].bodyHTML = questions[j].outerHTML;
			}
		}
	};

	function createElementFromHTML(htmlString) {
		var div = angular.element("<div />");
		div.html(htmlString);
		return div[0].firstChild;
	}

	function generateUUID() {
		var d = new Date().getTime();
		return BASE_UUID.replace(/[xy]/g, function replace(c) {
			var r = (d + Math.random() * 16) % 16 | 0;
			d = Math.floor(d / 16);
			return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
		});
	}

	function draftDialogBodyText() {
		var title = "";
		if ($scope.exam.title === "") {
			title = dxLocalize.get("NamelessExam");
		} else {
			title = $scope.exam.title;
		}

		return dxLocalize.get("LoadDraftExplanation").format(title, $filter("date")(new Date($scope.draftLastModified), "yyyy-MM-dd HH:mm:ss"));
	}

	$scope.toggleQuestionLibrary = function toggleQuestionLibrary() {
		$scope.showLibrary = !$scope.showLibrary;
	};

	$scope.saveAsNew = function saveAsNew() {
		var scope = $rootScope.$new();
		scope.item = {};
		scope.items = ExamRepository.exams;
		scope.item.title = "";

		scope.saveAsNew = function saveAsNewInner(title) {
			$scope.exam.title = title;
			$scope.save(true);
		};

		dxDialog.show({
			templateUrl: "partials/popups/save-as-new.html",
			$scope: scope,
		});
	};

	$scope.save = function save(saveAsOriginal, closeOnSave) {
		if (!validateExam() || $scope.isSaving) {
			return;
		}

		$scope.stopExamWatch();


		if (saveAsOriginal) {
			$scope.exam.id = 0;
			$scope.exam.ancestor = 0;
			$scope.exam.parent = 0;
			$scope.exam.at = new Date();
		}

		$scope.isSaving = true;

		// TODO: Handle error.
		var originalExamId = $scope.exam.id;
		var isOriginalExamShared = $scope.exam.userId !== dxSession.getUser().id;

		// Don't save external tool settings for tools belonging to another organization
		if (isOriginalExamShared && $scope.exam.organizationId !== dxSession.getRole().organizationId) {
			$scope.exam.externalToolSettings = [];
		}

		ExamRepository.save($scope.exam).then(function saveSuccess(exam) {
			if (saveAsOriginal) {
				for (var i = 0; i < $scope.exam.questions.length; i++) {
					var question = $scope.exam.questions[i];
					question.id = 0;
					if (containsAlternatives(question)) {
						for (var j = 0; j < question.alternatives.length; j++) {
							question.alternatives[j].id = 0;
						}
					}
				}
			}

			// A bit dirty, but the calls are happening faster than the DB-writes.
			$timeout(function timeoutSaveQuestions() {
				ExamRepository.saveQuestions(exam.id, $scope.exam.questions).then(function saveQuestionsSuccess(questions) {
					if (exam && questions) {
						$scope.exam = angular.copy(exam);
						$scope.exam.questions = angular.copy(questions);
						$scope.saveMessage = dxLocalize.get("Saved") + " " + $filter("date")(new Date(), "HH:mm:ss");
						$scope.exam.setDirty(false);
						$scope.hasSavedManually = true;
						$scope.$broadcast("CreateExamController:examTemplateSaved", $scope.exam);

						if ($scope.exam.gradingType === DX_GRADING_TYPES.FORMATIVE) {
							if ($scope.exam.gradingMatrix === null) {
								$rootScope.$broadcast("notification:info", dxLocalize.get("YouHaveNotAddedRubricToExam.Saving"));
							} else if ($scope.exam.notAllQuestionsHaveAbilities()) {
								$rootScope.$broadcast("notification:info", dxLocalize.get("AbilitiesHaveNotBeenSelectedForAllQuestions.Saving"));
							}
						}

						if (!isOriginalExamShared) {
							ExamDraftRepository.clear(originalExamId);
						}

						if ($scope.exam.id !== originalExamId) {
							examId = $scope.exam.id;
							preventReload = true;
							$location.path("/exam/edit/" + examId);
							$location.replace();
							setExamPrintUrl($scope.exam.id);
						}

						if (closeOnSave) {
							// We wrap the reroute to the exams page in a timeout so that the call to $location.replace()
							// has time to sync during the next digest cycle. Otherwise the browser history will not work as expected.
							$timeout(function timeoutCloseOnSave() {
								$location.url(DX_URLS.get("exams") + dxExamsNavigator(DX_EXAMS_STEPS.library, $scope.exam.id));
							});
						}
					} else {
						$scope.saveMessage = "FAILED TO SAVE.";
					}

					// Need to delay this for the animations to work as intended.
					$timeout(function timeoutStartExamWatch() {
						$scope.isSaving = false;
						$scope.startExamWatch();
					}, 10);
				}, function errorSavingExam() {
					$scope.isSaving = false;
					$rootScope.$broadcast("notification:error", "Could not save exam. Try again or contact support.");
				});
			}, 200);
		}, function errorSavingExam() {
			$scope.isSaving = false;
			$rootScope.$broadcast("notification:error", "Could not save exam. Try again or contact support.");
		});
	};

	$scope.autosaveDraft = function autosaveDraft() {
		if (!$scope.isSaving && $scope.exam.isDirty() && $scope.exam.userId === dxSession.getUser().id) {
			ExamDraftRepository.save($scope.exam.id, $scope.exam).then(function save() {
				$scope.exam.setDirty(false);
				$scope.saveMessage = dxLocalize.get("DraftSaved") + " " + $filter("date")(new Date(), "HH:mm:ss");
			});
		}
	};

	// Every 5 second.
	$scope.autosaveInterval = $interval($scope.autosaveDraft, 5000);

	$scope.$on("$destroy", function on() {
		$interval.cancel($scope.autosaveInterval);
		$document.off("click", hideHelpPopup);
		dxDialog.closeMostRecent();
	});

	$scope.removeImageFromQuestion = function removeImageFromQuestion(index, q) {
		q.images.splice(index, 1);
		q.setDirty(true);
	};

	$scope.goToError = function goToError(error) {
		var container = angular.element(".content-nailed");
		// We use getElementById here because jQuery doesn't support selectors with unescaped colons in them.
		var element = angular.element($document[0].getElementById(error.id));
		var extraPaddingTop = 200;
		dxScrollIntoView(container, element, extraPaddingTop);

		$scope.focusEditor(error.id.replace("about", "editor"));
	};

	$scope.toggleHelpPopup = function toggleHelpPopup($event) {
		$event.stopPropagation();
		if ($scope.showHelp) {
			hideHelpPopup($event);
		} else {
			$scope.showHelp = true;
			$document.on("click", hideHelpPopup);
		}
	};

	function hideHelpPopup(event) {
		if (event.isPropagationStopped()) {
			$scope.showHelp = false;
		} else {
			$scope.$apply(function apply() {
				$scope.showHelp = false;
			});
		}

		// Remove click listener after use. This prevents memory leak.
		$document.off("click", hideHelpPopup);
	}

	$scope.getDisplayName = function getDisplayName(questionType) {
		for (var i = 0; i < $scope.questionTypes.length; i++) {
			if ($scope.questionTypes[i].type === questionType) {
				return $scope.questionTypes[i].displayName;
			}
		}

		return null;
	};

	$scope.addMatrix = function addMatrix(matrix) {
		$scope.matrixToAdd = matrix;
		if ($scope.exam.gradingMatrix) {
			$scope.confirmRemoveMatrix("confirmedAddMatrix");
		} else {
			$scope.confirmedAddMatrix();
		}
	};

	$scope.confirmedAddMatrix = function confirmedAddMatrix() {
		dxDialog.closeMostRecent();

		if ($scope.matrixToAdd) {
			var matrixCopy = angular.copy($scope.matrixToAdd);
			matrixCopy.templateId = $scope.matrixToAdd.id;
			matrixCopy.id = 0;
			$scope.confirmedRemoveMatrix();
			$scope.exam.gradingMatrix = matrixCopy;
			$scope.exam.gradingMatrixId = 0;
		}
	};

	$scope.confirmRemoveMatrix = function confirmRemoveMatrix(confirmedMethodNameOption) {
		var confirmedMethodName = confirmedMethodNameOption || "confirmedRemoveMatrix";

		var confirmRemoval = false;
		for (var i = 0; i < $scope.exam.questions.length; i++) {
			if ($scope.exam.questions[i].hasMatrixAbilitiesEnabled()) {
				confirmRemoval = true;
			}
		}

		if (confirmRemoval) {
			dxDialog.confirm({
				title: dxLocalize.get("RemoveRubric"),
				body: dxLocalize.get("RemovingRubricFromExamWarning").format($scope.exam.gradingMatrix.title),
				acceptText: dxLocalize.get("RemoveRubric"),
				acceptCallback: $scope[confirmedMethodName],
				rejectText: dxLocalize.get("Cancel"),
			});
		} else {
			$scope[confirmedMethodName]();
		}
	};

	$scope.confirmedRemoveMatrix = function confirmedRemoveMatrix() {
		dxDialog.closeMostRecent();
		$scope.exam.gradingMatrix = null;
		$scope.exam.gradingMatrixId = 0;

		var results = [];
		for (var i = 0; i < $scope.exam.questions.length; i++) {
			$scope.exam.questions[i].removeMatrixAbilities();
			results.push($scope.exam.questions[i]);
		}

		return results;
	};

	$scope.removeQuestion = function removeQuestion(question, index) {
		delete $scope.editorFocus["editor-q-" + question.$$hashKey];
		$scope.exam.removeQuestion(index);
	};

	$scope.viewAttachedMatrix = function viewAttachedMatrix() {
		var scope = $rootScope.$new();
		scope.matrix = $scope.exam.gradingMatrix;

		dxDialog.show({
			templateUrl: "/partials/popups/view-grading-matrix.html",
			$scope: scope,
		});
	};

	$scope.sendGradingTypeSelectedEvent = function sendGradingTypeSelectedEvent(gradingType) {
		if (gradingType === DX_GRADING_TYPES.FORMATIVE) {
			dxEvent.create(DX_EVENT_NAME.EventCreateExamFormativeSelected);
		} else {
			dxEvent.create(DX_EVENT_NAME.EventCreateExamSummativeSelected);
		}
	};

	$scope.toggleAddMediaDropdown = function toggleAddMediaDropdown(event) {
		event.stopPropagation();
		angular.element(event.currentTarget.parentElement).find(".dropdown_menu").dropdown("toggle");
		$scope.showMediaWarning = true;
		$timeout(function overrideNextElementFocus() {
			angular.element(event.currentTarget)[0].focus();
		}, 0);
	};

	$scope.addOrEditOnlineResource = function addOrEditMediaDialog(resourceType, question, onlineResource) {
		var scope = $rootScope.$new();

		scope.resourceType = resourceType;
		scope.question = question;
		if (onlineResource) {
			scope.onlineResource = onlineResource;
		}

		dxDialog.show({
			templateUrl: "/tmpl/online-resources/online-resource-popup.html",
			$scope: scope,
		});
	};

	$scope.removeOnlineResource = function removeOnlineResource(onlineResources, onlineResource) {
		var i = onlineResources.indexOf(onlineResource);
		onlineResources.splice(i, 1);
	};

	$scope.focusEditor = function focusEditor(id) {
		// MIGRATION: Trigger Froala focus using flag until this parent component
		// is in Angular and we can call child methods using ViewChild
		$scope.editorFocus[id] = true;
	};

	function containsAlternatives(question) {
		return question.type === DX_QUESTION_TYPE.SINGLE_CHOICE && question.type === DX_QUESTION_TYPE.MULTIPLE_CHOICE;
	}

	$scope.togglePopMenuVisibility = function togglePopMenuVisibility(visible) {
		if (visible) {
			angular.element(".popMenu_container").addClass("popMenu_container-open");
		} else {
			angular.element(".popMenu_container").removeClass("popMenu_container-open");
		}
	};

	$scope.isActiveSettingsTab = function isActiveSettingsTab(tab) {
		return $scope.activeSettingsTab === tab;
	};

	$scope.setSettingsTab = function setSettingsTab(tab) {
		$scope.activeSettingsTab = tab;
	};

	function loadExternalTools() {
		$scope.enabledExternalTools = {};
		dxApi.v1.externalTools.list(dxSession.getRole().organizationId).then(function success(response) {
			$scope.externalTools = dxSorting.externalToolsSort(response.data);
			isExternalToolsLoaded = true;
			$scope.canCheckForDeletedExternalTools = isExternalToolsLoaded && isExamLoaded;
		}, function fail() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.CouldNotLoadError.Plural"));
		});
	}
	loadExternalTools();

	function showDeletedToolsDialog(deletedExternalToolSettings) {
		var deletedToolNames = deletedExternalToolSettings.map(function mapFn(settings) {
			return settings.title;
		});

		dxDialog.confirm({
			title: dxLocalize.get("ExternalTools.SomeDeletedWarning.Title"),
			body: dxLocalize.get("ExternalTools.SomeDeletedWarning.Body", deletedToolNames.join(", ")),
			acceptText: dxLocalize.get("OkIUnderstand"),
			acceptCallback: function onAccept() {
				deletedExternalToolSettings.forEach(function forEachFn(setting) {
					$scope.exam.removeExternalToolSettings(setting.externalToolId);
				});
				dxDialog.closeMostRecent();
			},
			rejectText: dxLocalize.get("RemindMeLater"),
			escapeToClose: false,
			clickOutsideToClose: false,
			allowOtherDialogsToClose: true,
		});
	}

	$scope.$watch("canCheckForDeletedExternalTools", function watchExamFn(canCheckForDeletedExternalTools) {
		if (canCheckForDeletedExternalTools) {
			checkForDeletedExternalTools();
		}
	});

	function checkForDeletedExternalTools() {
		var availableExternalToolIds = $scope.externalTools.map(function mapFn(exTool) {
			return exTool.id;
		});

		var deletedExternalToolSettings = $scope.exam.getDeletedExternalToolSettings(availableExternalToolIds);
		if (deletedExternalToolSettings.length > 0 && $scope.exam.userId === dxSession.getUser().id) {
			showDeletedToolsDialog(deletedExternalToolSettings);
		}
	}
});
